import type { JSX } from 'solid-js';
import { t } from '../../i18n';
import type { TerminalTimeMode } from '../../lib/terminal/use-terminal-panes';

// The Terminal window's title bar (#4395, epic #4391): "developerz-ai / <org> /
// terminal", the mono breadcrumb the canvas puts atop every terminal-shaped
// surface — the WINDOW's own chrome, above the pane tree.
//
// `<h1>`, styled via `.terminal__path`'s existing class selector (not a tag
// selector, so this costs nothing visually): every route this app mounts has
// exactly one, `apps/dashboard/e2e/mobile-390.spec.ts` enforces it, and this
// bleed page has no `<PageHeader/>` to supply one otherwise (#4395 review —
// CI's own e2e lanes were red on this before the fix).
//
// ONE `<h1>` STAYS ONE, EVEN WITH PANES (#4397). This component used to carry
// a `focused` prop foreshadowing a second title bar per pane — that pane-level
// focus state is now `TerminalPaneTitlebar.tsx`'s own concern, a `<div>`
// toolbar, never a second heading. Splitting into four panes must never
// produce four `<h1>`s on one page.

//
// THE TIMESTAMP TOGGLE (#4401) lives here, not per pane: absolute vs relative
// is one window-wide reading preference, persisted like the layout. A toggle
// button with a FIXED label and `aria-pressed` — a label that flips as well
// would say the state twice and contradict itself on half the reads.
export function TerminalTitlebar(props: {
  readonly org: string;
  readonly timeMode: TerminalTimeMode;
  readonly onToggleTimeMode: () => void;
}): JSX.Element {
  return (
    <header class="terminal__titlebar">
      <h1 class="terminal__path">{t('terminal.window_title', { org: props.org })}</h1>
      <button
        type="button"
        class="terminal__pane-action"
        aria-pressed={props.timeMode === 'relative'}
        onClick={props.onToggleTimeMode}
      >
        {t('terminal.time_relative_toggle')}
      </button>
    </header>
  );
}
